import React, { useEffect, useContext, useState } from "react";

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import {
  ModuleText,
  ModuleSubTitle,
  ModuleFormWrapper,
  ModuleFormItemLongWrapper,
  ModulePaperWrapper,
} from "../../lib-atomic-design-section";
import { LocalStorage } from "../../lib-atomic-functions";
/* packages */
import postcodelist from "./postcodelist";

const index = (props) => {
  const productsLS = LocalStorage.getLS().products;
  const promocodeLS = LocalStorage.getLS().promocode;
  const feesLS = LocalStorage.getLS().fees;
  const feesDetailsLS = LocalStorage.getLS().feesDetails;
  const { product, fees, promocode } = useContext(GlobalContext);
  const [feeMethod, setFeeMethod] = useState("");
  const [feeAmount, setFeeAmount] = useState(10.0);
  const [feeExtra, setFeeExtra] = useState(0.0);
  const [defaultFeesDetails, setDefaultFeesDetails] = useState(null);

  useEffect(() => {
    handleFeeTotal();
  }, [product, promocode.state.data]);

  const handleFeeTotal = () => {
    const productsLS = LocalStorage.getLS().products || [];
    const infoLS =
      LocalStorage.getLS().user || LocalStorage.getLS().guest;

      let subtotal = 0;
    productsLS.forEach(item => {
      subtotal += Number(item.value) * Number(item.quantity);
    });

    const isPromoValid =
      promocode &&
      promocode.state &&
      promocode.state.data &&
      promocode.state.data.status === true;

    if (isPromoValid && subtotal >= 2000) {
      setFeeAmount(0);

      LocalStorage.addLS("feesDetails", {
        courier: 0,
        pAndH: feeExtra,
      });
    } else {
      const normalCourierFee = 10;

      setFeeAmount(normalCourierFee);

      LocalStorage.addLS("feesDetails", {
        courier: normalCourierFee,
        pAndH: feeExtra,
      });
    }
  };

  return (
    <ModuleFormItemLongWrapper>
      <ModulePaperWrapper>
        <ModuleFormWrapper>
          <ModuleFormItemLongWrapper>
            <ModuleSubTitle>
              <b>Courier Fee {feeMethod !== "" && "(" + feeMethod + ")"}</b>
            </ModuleSubTitle>
            <div
              style={{ width: "100%", display: "flex", flexDirection: "row" }}
            >
              <div style={{ width: "35%", paddingLeft: 20 }}>
                <ModuleText>
                  <b>Courier Cost</b>
                </ModuleText>
              </div>
              <div style={{ width: "65%" }}>
                <ModuleText>
                  <b>{`$${feeAmount.toFixed(2)}`}</b>
                </ModuleText>
              </div>
            </div>
            <div
              style={{ width: "100%", display: "flex", flexDirection: "row" }}
            >
              <div style={{ width: "35%", paddingLeft: 20 }}>
                <ModuleText>
                  <b>Packaging & Handling</b>
                </ModuleText>
              </div>
              <div style={{ width: "65%" }}>
                <ModuleText>
                  <b>{`$${feeExtra.toFixed(2)}`}</b>
                  <small> *Complimentary handling fee</small>
                </ModuleText>
              </div>
            </div>
          </ModuleFormItemLongWrapper>
        </ModuleFormWrapper>
      </ModulePaperWrapper>
    </ModuleFormItemLongWrapper>
  );
};

export default index;
